import { prefixer, createApiConsts } from '../../../Helpers/constants'

export const ACTIONS = {
  EVALUATE: 'contact_goal_action_evaluate',
  CALIBRATE: 'contact_goal_action_calibrate',
  REVIEW: 'contact_goal_action_review',
} as const

//I want to make it easier to create these constants for APIs
const createPrefixedConst = prefixer('CREATE_TASK')
const createPrefixedApiConsts = <ApiName extends string>(apiName: ApiName) => createApiConsts(createPrefixedConst(apiName))

export const SELECT_ACTION = createPrefixedConst('SELECT_ACTION')
export const GET_ACTIONS = createPrefixedApiConsts('GET_ACTIONS')
export const GET_CONTACT_GOAL_CLASSIFIER = createPrefixedApiConsts('GET_CONTACT_GOAL_CLASSIFIER')
export const GET_CONTACT_GOAL_STATUS = createPrefixedApiConsts('GET_CONTACT_GOAL_STATUS')
export const GET_CONTACT_GOAL_TIME = createPrefixedApiConsts('GET_CONTACT_GOAL_TIME')
export const GET_CONTACT_GOAL_TYPE = createPrefixedApiConsts('GET_CONTACT_GOAL_TYPE')
export const GET_CONTACT_GOAL_WHO = createPrefixedApiConsts('GET_CONTACT_GOAL_WHO')
export const GET_EVALUATE_PEOPLE = createPrefixedApiConsts('GET_EVALUATE_PEOPLE')
export const GET_VIEW_CONTACT_GOAL_PEOPLE = createPrefixedApiConsts('GET_VIEW_CONTACT_GOAL_PEOPLE')
export const SAVE_CONTACT_GOAL = createPrefixedApiConsts('SAVE_CONTACT_GOAL')
